import { createContext, useContext, useEffect, useState } from "react";
import api from "@/api";

const SiteCtx = createContext(null);

export const SiteProvider = ({ children }) => {
  const [site, setSite] = useState(null);

  useEffect(() => {
    api.get("/settings/site").then((r) => setSite(r.data)).catch(() => {});
  }, []);

  return <SiteCtx.Provider value={{ site, setSite }}>{children}</SiteCtx.Provider>;
};

export const useSite = () => useContext(SiteCtx);
